import { Component, Input } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { SearchParams } from '../../api/models/search-params';
import { SearchEventPublisher } from '../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../shared/model/search-event-type-enum';

@Component({
  selector: 'app-search-message-box',
  templateUrl: './search-message-box.component.html',
  styleUrls: ['./search-message-box.component.scss'],
})
export class SearchMessageBoxComponent {
  @Input()
  searchResult?: SearchResult;

  constructor(private searchEventPublisher: SearchEventPublisher) {}

  public triggerSearch(params: SearchParams) {
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.SEARCH_FROM_MESSAGE_BOX, params);
  }
}
